// extracted by mini-css-extract-plugin
module.exports = {"clickableTable":"_1TIxtDrtOj497wjbI-JEAt","ticketTable":"_2bVXnV_rRDNlRvMeYaC29Y","searchInput":"_1MkesaGKbAbkiZOAxxWQGi"};